import { render, staticRenderFns } from "./Booklets.vue?vue&type=template&id=3fe2837a&scoped=true&"
import script from "./Booklets.vue?vue&type=script&lang=ts&"
export * from "./Booklets.vue?vue&type=script&lang=ts&"
import style0 from "./Booklets.vue?vue&type=style&index=0&id=3fe2837a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe2837a",
  null
  
)

export default component.exports